// extracted by mini-css-extract-plugin
module.exports = {"PM_CouponCodeField":"Shopping_PM_CouponCodeField__ZUEX8"};